import { useEffect } from 'react'
import { trackWithExtra } from '../../../lib/tracking'
import { PageContainer } from '../../components'
import PostForm from '../../components/forms/PostForm'
import type { BargainUserInfo, Shop, Theme } from '../../types'

interface PostFormPageProps {
  selected_theme: Theme
  postable_themes: Theme[]
  bargain_user_info: BargainUserInfo
  myarea_shops: Shop[]
}

const PostFormPage: React.FC<PostFormPageProps> = ({
  selected_theme,
  postable_themes,
  bargain_user_info,
  myarea_shops,
}) => {
  useEffect(() => {
    void trackWithExtra('bargain.message_board.post.form.imp', {
      path: location.pathname,
    })
  }, [])

  return (
    <PageContainer maxWidth="640px">
      <PostForm
        selectedTheme={selected_theme}
        postableThemes={postable_themes}
        bargain_user_info={bargain_user_info}
        myarea_shops={myarea_shops}
      />
    </PageContainer>
  )
}

export default PostFormPage
